import {
  gae,
  gaeApp,
  gaeAppNavigate,
  gaeUserNavigate,
  gaPageView
} from '../helpers/Analytics';
import { isPinCodeWrong, isPinCodeRequired } from './utils';

export function gaeHome(action) {
  gae('HOME', action, '', '', true);
}

export function gaPinCodeRequired() {
  gaeHome('PIN_CODE_REQUIRED');
}

export function gaCheckPinCode() {
  gaeHome('HOME.CHECK_PIN_CODE');
}

export function gaWrongPinCode() {
  gaeHome('WRONG_PIN_CODE');
}

export function gaNavigateToList(byUser) {
  byUser ? gaeUserNavigate('List') : gaeAppNavigate('List');
}

export function gaNavigateBack() {
  gaeUserNavigate('Back to Home');
}

export function gaNavigateQrCode() {
  gaeUserNavigate('Back to QrCode');
}

export function gaNavigateToPayment() {
  gaeUserNavigate('Payment');
}

export function gaErrorOnRequest(message) {
  gaeApp('LOAD_REQUEST_ERROR', message);
}

export function gaAlreadySubmitted() {
  gaeHome('REQUEST_ALREADY_SUBMITTED');
}

export function gaHomePageView() {
  gaPageView('Home');
}

export function gaPropsToGAEvent(props) {
  if (isPinCodeRequired(props)) {
    gaPinCodeRequired();
  } else if (isPinCodeWrong(props)) {
    gaWrongPinCode();
  } else if (props.authOnStartRequired) {
    gaeApp('SMS_AUTH_REQUIRED');
  } else if (props.closed) {
    gaeApp('REQUEST_IS_CLOSED');
  } else if (
    !props.isFetching &&
    !(props.requestedDocuments && props.requestedDocuments.length)
  ) {
    gaeApp('REQUEST_DOES_NOT_EXISTS');
  } else if (
    !props.isFetching &&
    !props.scanStarted &&
    props.requestedDocuments &&
    props.requestedDocuments.length
  ) {
    gaeApp('RECEIVED_REQUESTED_DOCUMENTS');
  }
}
